import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import apiUrl from "../../services/api";

// Async thunk for login
export const contactUsApi = createAsyncThunk(
  "contach/contactUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl.contactUs, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "contact us failed");
    }
  }
);

const initialState = {
  user: null,
  loading: false,
  error: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(contactUsApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(contactUsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isLoggedIn = true;
      })
      .addCase(contactUsApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoggedIn = false;
      });
  },
});

export default contactSlice.reducer;
